import { Component, Input, OnInit } from '@angular/core'
import { SearchUtilsService } from '../../../services/search-utils.service'
import { of } from 'rxjs'
import { triggerSmoothCollapseAnimation } from '../../../../shared/animations/smooth-collapse.animation'
import { Product, TranslationService } from '@spartacus/core'
import { UrlUtils } from '../../../../shared/utils/url-utils'
import { DataAnalyticsClickSource, MbConstants } from '../../../../shared/mb-constants'

@Component({
  selector: 'mb-search-result-item-wrapper',
  templateUrl: './mb-search-result-item-wrapper.component.html',
  styleUrls: ['./mb-search-result-item-wrapper.component.scss'],
  animations: [triggerSmoothCollapseAnimation]
})
export class MbSearchResultItemWrapperComponent implements OnInit {

  @Input() model: Product | undefined
  @Input() areResultsCollapsed = true
  isFacetExpanded$ = this.searchFilterService.isFacetsExpanded$
  url: string | undefined
  fragment: string | undefined
  constants = MbConstants

  dataAnalyticsClickSource = DataAnalyticsClickSource.LIST

  constructor (private searchFilterService: SearchUtilsService,
              private translationService: TranslationService) {
  }

  ngOnInit () {
    this.url = UrlUtils.getPath(this.model?.url)?.toLowerCase()
    this.fragment = UrlUtils.getFragment(this.model?.url)?.toLowerCase()
  }

  handleExpandButtonClick () {
    this.areResultsCollapsed = !this.areResultsCollapsed
  }

  get hasPriceOnRequest () {
    return this.model?.priceOnRequest
  }

  get isVariant () {
    return this.model?.variantOptions?.length === 1
  }

  get firstVariant () {
    const { variantOptions } = this.model || {}
    return variantOptions?.length && variantOptions[0] || undefined
  }

  get regulatoryStatus$ () {
    const statuses = this.model?.variantOptions?.map(variant => variant.regulatoryStatus).filter(status => !!status)
    if (!statuses?.length) {
      return of('')
    }
    const differentStatuses = statuses?.filter(status => status !== statuses[0])
    if (!differentStatuses?.length) {
      return of(statuses[0])
    } else {
      return this.translationService.translate('searchResultItem.regulatoryStatus')
    }
  }
}
